import Vue from 'vue';
import exciseEntryTransformer from './../../transformers/exciseEntry';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const report = exciseEntryTransformer.fetchCollection(data.data);
  let pagination = {};
  if (data.pagination) {
    pagination = paginationTransformer.fetch(data.pagination);
  }
  resolve({ report, pagination });
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/excise_entries', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/exciseEntry/entries.js